export const getValueFromFormData = (formData: any, name: string) => {
	if (!formData) return "";
	if (name.includes(".")) {
		return name
			.split(".")
			.reduce((obj, key) => (obj ? obj[key] : ""), formData);
	}
	return formData[name] ?? "";
};
